import MuiInputBase, { InputBaseProps as MuiInputBaseProps } from '@mui/material/InputBase';

export type InputBaseProps = MuiInputBaseProps;

export const InputBase = (props: InputBaseProps) => {
  return <MuiInputBase {...props} />;
};
